import { useMemo } from "react";
import { useGetTableValueQuery } from "../../api/rtk/base/slices/tablesApiSlice";

const QUERIES = [
  { url: "objects/LandSingleOwners", right: "Собственность" },
  { url: "objects/LandOwners",       right: "Долевая собственность" },
  { url: "objects/LandOtherUsers" }
] as const;

export function useLandLotOwners(landLotId?: string) {
  const results = QUERIES.map(q =>
    useGetTableValueQuery(
      { tableValueUrl: q.url, filterStringArray: [`LandLotId eq ${landLotId}`], pages: true },
      { skip: !landLotId }
    )
  );

  const isLoading = results.some(r => r.isFetching);
  const isError   = results.some(r => r.isError);

  const owners = useMemo(() => {
    if (results.every(r => r.data)) {
      const [single, owners, other] = results.map(r => r.data!.value);

      const addType = (arr: any[], type?: string) =>
        type ? arr.map(o => ({ ...o, RightTypeString: type })) : arr;

      return [
        ...addType(single, "Собственность"),
        ...addType(owners, "Долевая собственность"),
        ...other
      ];
    }
    return [];
  }, results);

  return { owners, isLoading, isError };
}